<template>
    <TheSkinSwiper :showSkinArticles="neutralSkin" skinType="中性肌" />
</template>

<script setup>
import { ref } from 'vue';
import TheSkinSwiper from '@/components/widget/TheSkinSwiper.vue';
import data from '@/assets/data/neutralSkin.json';

let neutralSkin = ref(data.articles);
</script>
